import { LuminateRuntimeException } from '@luminate/luminate-ts-sdk';
import * as SecureStore from 'expo-secure-store';
import Cookies from 'js-cookie';
import { PlatformUtils } from './PlatformUtils';
export class StorageService {
    static create = () => {
        return new StorageService();
    };
    getValueFromStorage = async (key) => {
        let keyValue;
        if (!PlatformUtils.isWeb()) {
            try {
                keyValue = await SecureStore.getItemAsync(key);
            }
            catch (ex) {
                throw new LuminateRuntimeException(`Unable to retrieve ${key} from storage.`, ex);
            }
        }
        else {
            keyValue = Cookies.get(key);
        }
        return keyValue === undefined || keyValue === null ? undefined : keyValue;
    };
    getObjectFromStorage = async (key) => {
        const keyValue = await this.getValueFromStorage(key);
        return keyValue ? JSON.parse(keyValue) : undefined;
    };
    getStringFromStorage = async (key) => {
        return await this.getValueFromStorage(key);
    };
    getNumberFromStorage = async (key, radix) => {
        const keyValue = await this.getValueFromStorage(key);
        return keyValue ? parseInt(keyValue, radix) : undefined;
    };
    getBooleanFromStorage = async (key, defaultValue) => {
        try {
            const keyValue = await this.getValueFromStorage(key);
            return keyValue ? JSON.parse(keyValue) : defaultValue;
        }
        catch (ex) {
            throw new LuminateRuntimeException(`Unable to retrieve boolean ${key} from storage.`, ex);
        }
    };
    addToStorage = async (key, value) => {
        let keyValue;
        if (typeof value !== 'string') {
            keyValue = JSON.stringify(value);
        }
        else {
            keyValue = value;
        }
        if (!PlatformUtils.isWeb()) {
            await SecureStore.setItemAsync(key, keyValue);
        }
        else {
            Cookies.set(key, keyValue);
        }
    };
    removeFromStorage = async (key) => {
        if (!PlatformUtils.isWeb()) {
            await SecureStore.deleteItemAsync(key);
        }
        else {
            Cookies.remove(key);
        }
    };
}
